import React, { useContext, useEffect, useRef, useState } from 'react';
import { FaStar, FaUserCircle, FaVideo } from 'react-icons/fa';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { RiVerifiedBadgeFill } from 'react-icons/ri';
import { Link, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import briefcaseicon from "../../assets/Icon/briefcase.svg";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';
const DocDetail = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);
    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const [personeData, setPersoneData] = useState([]);
    const [videoData, setVideoData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiloading, setApiLoading] = useState(false);
    const [page, setPage] = useState(1);

    const navigate = useNavigate();
    const hasReachedBottom = useRef(false);
    const NoMoreDataRef = useRef(true);
    const selectBtnRef = useRef(0);

    const Data = sessionStorage.getItem("Docdetails");

    if (Data) {
        var { title, path, pagename, id } = JSON.parse(Data);
    }

    const NavigateHandle = (title, Id) => {
        navigate(`/doctor-profile/${id}/${Id}`);
        sessionStorage.setItem("Docprofile", JSON.stringify({ id: Id, department_id: id, title: title, path: "/doctor-details", pagename: "Doctor Details" }));
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        HandlefetchInPersonData(1);
    }, []);

    const HandlefetchInPersonData = (page) => {
        setApiLoading(true);
        navigator.geolocation.getCurrentPosition(position => {

            const lat = String(position.coords.latitude);
            const long = String(position.coords.longitude);

            axios.post(`${ApiBaseUrl}/customer/dep_type_client_doctor`, { department_id: id, lat: lat, lon: long, page })
                .then((res) => {
                    const { clinic_visit, ResponseCode } = res.data;
                    console.log("dep_type_client_doctor", res);
                    if (ResponseCode === 200) {
                        if (clinic_visit.length === 0) NoMoreDataRef.current = false;
                        if (page === 1) {
                            setPersoneData(clinic_visit);
                        } else {
                            setPersoneData(prev => [...prev, ...clinic_visit]);
                        }
                    }
                    setLoading(false);
                    setApiLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                });
        });

    }

    const HandlefetchVideoData = (page) => {
        navigator.geolocation.getCurrentPosition(position => {
            const lat = String(position.coords.latitude);
            const long = String(position.coords.longitude);

            axios.post(`${ApiBaseUrl}/customer/dep_type_video_doctor`, { department_id: id, lat: lat, lon: long, page })
                .then((res) => {
                    const { video_consult, ResponseCode } = res.data;
                    // console.log("dep_type_video_doctor", res);
                    if (ResponseCode === 200) {
                        if (video_consult.length === 0) NoMoreDataRef.current = false;
                        if (page === 1) {
                            setVideoData(video_consult);
                        } else {
                            setVideoData(prev => [...prev, ...video_consult]);
                        }
                    }
                    setApiLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                });
        });

    }

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            const clientHeight = window.innerHeight;

            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

            if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
                hasReachedBottom.current = true;
                setPage(prev => prev + 1);

            } else if (!isAtBottom && hasReachedBottom.current) {
                hasReachedBottom.current = false;
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (page === 1 || !NoMoreDataRef.current) return;

        if (selectBtnRef.current === 0) {
            HandlefetchInPersonData(page);
        } else {
            HandlefetchVideoData(page);
        }
    }, [page])

    const HandleSelectButton = (index) => {
        selectBtnRef.current = index;
        NoMoreDataRef.current = true;
        setPage(1);
        setApiLoading(true);

        if (index === 0) {
            HandlefetchInPersonData(1);
        } else {
            HandlefetchVideoData(1);
        }
    };
    return (
        <div>
            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="width-container details max-_430_:pb-0">

                    <div className="flex items-center justify-between top-section">
                        <Link to="/" className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black">
                            <IoIosArrowBack className=' group-hover:text-white' />
                            <h1 className='font-[500] group-hover:text-white'> {t("Go Home")}</h1>
                        </Link>
                        <div className="flex items-center gap-[10px] max-_430_:hidden">
                            <Link to={path} className='font-[500] text-gray-700'>{t(pagename)}</Link>
                            <IoIosArrowForward />
                            <h1 className='font-[500] text-gray-400 pagename'>{title}</h1>
                        </div>
                        <div className="border-[2px] border-gray-200 rounded-[50px] px-[20px] py-[2px] hidden max-_430_:block">
                            <Link to={path} className='font-[500] text-gray-600'>{t("Back")}</Link>
                        </div>
                    </div>

                    <div className="flex justify-center mt-[25px]">
                        <div className="bg-[#F6F7F8] Select-btn p-[5px] rounded-[50px] flex gap-[20px]">
                            <button onClick={() => HandleSelectButton(0)} className={`${selectBtnRef.current === 0 && "active"}`}><FaUserCircle className='text-[20px]' />{t("In Person")}</button>
                            <button onClick={() => HandleSelectButton(1)} className={`${selectBtnRef.current === 1 && "active"}`}><FaVideo className='text-[20px]' />{t("Video Visit")}</button>
                        </div>
                    </div>

                    {apiloading
                        ? <Loading CustomeStyle="h-[500px] w-full flex items-center justify-center bg-white" />
                        : <div className="mt-[30px] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                            {selectBtnRef.current === 0 && (personeData.length >= 1 ? personeData.map((doc, index) => {
                                return <div key={index} onClick={() => NavigateHandle(doc.title, doc.id)} className="rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-xl transition-all duration-300 group h-full overflow-hidden">
                                    <div className="p-3 sm:p-4">
                                        <div className="flex items-start gap-2 sm:gap-3 mb-2 sm:mb-3 min-h-[90px] sm:min-h-[100px]">
                                            <div className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full overflow-hidden flex-shrink-0 bg-gradient-to-br from-gray-100 to-gray-200 cursor-pointer hover:ring-2 hover:ring-[--button-color] transition-all">
                                                <ImageLoad src={ImgBaseUrl + doc.logo} CustomeStyle={"object-cover"} alt={"Doctor img"} />
                                            </div>
                                            <div className="flex-1 min-w-0 overflow-hidden">
                                                <div className="mb-0.5 sm:mb-1 min-h-[14px] sm:min-h-[16px]">
                                                    <span class="inline-block text-[9px] sm:text-[10px] md:text-xs font-medium text-[#4038FF] bg-[#4038FF]/10 px-1.5 sm:px-2 py-0.5 rounded">{doc.title}</span>
                                                </div>
                                                <h3 className="text-sm sm:text-base md:text-lg font-bold text-gray-900 mb-0.5 line-clamp-1 group-hover:text-gray-700 transition-colors min-h-[18px] sm:min-h-[22px] cursor-pointer">{doc.title}</h3>
                                                <div className="mb-2 sm:mb-2.5 min-h-[12px] sm:min-h-[28px]">
                                                    <p className="text-[9px] sm:text-[10px] md:text-xs text-gray-500 line-clamp-1 sm:line-clamp-2">{doc.subtitle}</p>
                                                </div>
                                                <div className="flex items-center gap-2 sm:gap-3 text-[10px] sm:text-xs mb-2 sm:mb-2.5">
                                                    {doc.avg_star !== 0
                                                        ? <div className="flex items-center gap-0.5 sm:gap-1 bg-green-50 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star w-2.5 h-2.5 sm:w-3 sm:h-3 fill-green-500 text-green-500" aria-hidden="true">
                                                                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                                                            </svg>
                                                            <span className="font-semibold text-green-700">{doc.avg_star}</span>
                                                            <span className="text-gray-500 hidden sm:inline">({doc.tot_review})</span>
                                                        </div>
                                                        : <div className="flex items-center gap-0.5 sm:gap-1 text-gray-500">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star w-2.5 h-2.5 sm:w-3 sm:h-3" aria-hidden="true">
                                                                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                                                            </svg>
                                                            <span>{t("No review")}</span>
                                                        </div>}

                                                    <div className="flex items-center gap-0.5 sm:gap-1 text-gray-600">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-award w-2.5 h-2.5 sm:w-3 sm:h-3" aria-hidden="true">
                                                            <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                                                            <circle cx="12" cy="8" r="6"></circle>
                                                        </svg>
                                                        <span>{doc.year_of_experience} {t("years")}</span>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-3">
                                                    <div className="icon-box">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                                            <path d="M12 7v4"></path>
                                                            <path d="M14 21v-3a2 2 0 0 0-4 0v3"></path>
                                                            <path d="M14 9h-4"></path>
                                                            <path d="M18 11h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2"></path>
                                                            <path d="M18 21V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16"></path>
                                                        </svg>
                                                    </div>
                                                    <div className="leading-5 me-[4px]">
                                                        <h1 className='text-[14px] text-gray-600'>{t("Consultation Fee")}</h1>
                                                        <span className='font-medium'>{currency}{doc.min_inp_price} - {currency}{doc.max_inp_price}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button className='book-btn'>{t("Book Appointment")}</button>
                                    </div>
                                </div>
                            })
                                : <div className='w-[100%] h-[300px] flex items-center justify-center'>
                                    <h1 className='font-[500] text-[20px]'>{t("No Doctor available in your area.")}</h1>
                                </div>
                            )}

                            {selectBtnRef.current === 1 && (videoData.length >= 1 ? personeData.map((doc, index) => {
                                return <div key={index} onClick={() => NavigateHandle(doc.title, doc.id)} className="rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-xl transition-all duration-300 group h-full overflow-hidden">
                                    <div className="p-3 sm:p-4">
                                        <div className="flex items-start gap-2 sm:gap-3 mb-2 sm:mb-3 min-h-[90px] sm:min-h-[100px]">
                                            <div className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full overflow-hidden flex-shrink-0 bg-gradient-to-br from-gray-100 to-gray-200 cursor-pointer hover:ring-2 hover:ring-[--button-color] transition-all">
                                                <ImageLoad src={ImgBaseUrl + doc.logo} CustomeStyle={"object-cover"} alt={"Doctor img"} />
                                            </div>
                                            <div className="flex-1 min-w-0 overflow-hidden">
                                                <div className="mb-0.5 sm:mb-1 min-h-[14px] sm:min-h-[16px]">
                                                    <span class="inline-block text-[9px] sm:text-[10px] md:text-xs font-medium text-[#4038FF] bg-[#4038FF]/10 px-1.5 sm:px-2 py-0.5 rounded">{doc.title}</span>
                                                </div>
                                                <h3 className="text-sm sm:text-base md:text-lg font-bold text-gray-900 mb-0.5 line-clamp-1 group-hover:text-gray-700 transition-colors min-h-[18px] sm:min-h-[22px] cursor-pointer">{doc.title}</h3>
                                                <div className="mb-2 sm:mb-2.5 min-h-[12px] sm:min-h-[28px]">
                                                    <p className="text-[9px] sm:text-[10px] md:text-xs text-gray-500 line-clamp-1 sm:line-clamp-2">{doc.subtitle}</p>
                                                </div>
                                                <div className="flex items-center gap-2 sm:gap-3 text-[10px] sm:text-xs mb-2 sm:mb-2.5">
                                                    {doc.avg_star !== 0
                                                        ? <div className="flex items-center gap-0.5 sm:gap-1 bg-green-50 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star w-2.5 h-2.5 sm:w-3 sm:h-3 fill-green-500 text-green-500" aria-hidden="true">
                                                                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                                                            </svg>
                                                            <span className="font-semibold text-green-700">{doc.avg_star}</span>
                                                            <span className="text-gray-500 hidden sm:inline">({doc.tot_review})</span>
                                                        </div>
                                                        : <div className="flex items-center gap-0.5 sm:gap-1 text-gray-500">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star w-2.5 h-2.5 sm:w-3 sm:h-3" aria-hidden="true">
                                                                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                                                            </svg>
                                                            <span>{t("No review")}</span>
                                                        </div>}

                                                    <div className="flex items-center gap-0.5 sm:gap-1 text-gray-600">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-award w-2.5 h-2.5 sm:w-3 sm:h-3" aria-hidden="true">
                                                            <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                                                            <circle cx="12" cy="8" r="6"></circle>
                                                        </svg>
                                                        <span>{doc.year_of_experience} {t("years")}</span>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-3">
                                                    <div className="icon-box">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                                            <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"></path>
                                                            <rect x="2" y="6" width="14" height="12" rx="2"></rect>
                                                        </svg>
                                                    </div>
                                                    <div className="leading-5 me-[4px]">
                                                        <h1 className='text-[14px] text-gray-600'>{t("Video Visit")}</h1>
                                                        <span className='font-medium'>{currency + doc.min_vid_price} - {currency + doc.max_vid_price}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button className='book-btn'>{t("Book Appointment")}</button>
                                    </div>
                                </div>
                            })
                                : <div className='w-[100%] h-[300px] flex items-center justify-center'>
                                    <h1 className='font-[500] text-[20px]'>{t("No Doctor available in your area.")}</h1>
                                </div>
                            )}

                        </div>}
                </div>}
        </div>
    )
}

export default DocDetail